import { Grid as PlaceholderContainer } from '~/src/common/components/ProductsGrid/layout';
import { ProductPlaceholder as PlaceholderItem } from '~/src/screens/CatalogContent/ListProductsScreen/layout';

type Props = { count: number };

const LoadingSmall = ({ count }: Props) => (
  <PlaceholderContainer>
    {Array.from({ length: count }, (_, index) => (
      <PlaceholderItem key={index} />
    ))}
  </PlaceholderContainer>
);

export default LoadingSmall;
